import React from "react";

class AcceptRoles extends React.Component {
    render () {
        return <div>AcceptRoles</div>
    }
}

export default AcceptRoles